// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xlargeOnConfined-superElipse-411c6e64","strokeWidth":"super-ellipse-skins-xlargeOnConfined-strokeWidth-0b06c356"};